import { api } from "../../../../utils/api";

export async function deleteBrokerQueue(data) {
  try {
    const response = await api.delete(`/broker_queue`, {
      data: data,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}